export const TRAVELER_V2_API_URL_KEY = 'travelerApiUrl';
export const TRAVELER_V2_API_ENDPOINT = '/travel/v2/travel_services/traveler/details';
export const TLS_ONLINE_CLIENT_ID = 'TLSONLINE';
export const HIPED_ENC_TYPE = 'ENC_HIPED';
